import AssistantChatRuntime from 'components/Chat/AssistantChatRuntime';
import ChatPanelView from 'components/Chat/ChatPanelView';
import { useWebsocket } from 'contexts/websocket';
import useChatPanelViewModel from 'hooks/chat/useChatPanelViewModel';
import { useEffect, useState } from 'react';
import { Loading } from 'shell/components';

const ChatPanelRuntime = ({
    chat,
    fileKey,
    hasOlderMessages,
    hideBackButton = false,
    hideComposer = false,
    isBootstrapping,
    isLoadingOlderMessages,
    isOpen,
    onBack,
    onChatRequestStateChange,
    onLoadOlderMessages,
    onSuggestionSelected,
    showSuggestions = false,
    suggestions = [],
    viewModel,
}) => {
    const { isConnected, onMessage, sendMessage } = useWebsocket();
    const [shouldScrollToBottomOnInitialize, setShouldScrollToBottomOnInitialize] = useState(isOpen);

    useEffect(() => {
        if (!isOpen) {
            setShouldScrollToBottomOnInitialize(false);
            return;
        }

        setShouldScrollToBottomOnInitialize(true);
    }, [isOpen]);

    useEffect(() => {
        if (!shouldScrollToBottomOnInitialize) return;

        const frameId = requestAnimationFrame(() => {
            setShouldScrollToBottomOnInitialize(false);
        });

        return () => {
            cancelAnimationFrame(frameId);
        };
    }, [shouldScrollToBottomOnInitialize]);

    if (isBootstrapping) {
        return <Loading />;
    }

    return (
        <AssistantChatRuntime
            chat={chat}
            fileKey={fileKey}
            isConnected={isConnected}
            onChatRequestStateChange={onChatRequestStateChange}
            onMessage={onMessage}
            sendMessage={sendMessage}
        >
            <ChatPanelRuntimeContent
                hasOlderMessages={hasOlderMessages}
                hideBackButton={hideBackButton}
                hideComposer={hideComposer}
                isConnected={isConnected}
                isLoadingOlderMessages={isLoadingOlderMessages}
                onBack={onBack}
                onLoadOlderMessages={onLoadOlderMessages}
                onSuggestionSelected={onSuggestionSelected}
                shouldScrollToBottomOnInitialize={shouldScrollToBottomOnInitialize}
                showSuggestions={showSuggestions}
                suggestions={suggestions}
                viewModel={viewModel}
            />
        </AssistantChatRuntime>
    );
};

const ChatPanelRuntimeContent = (props) => {
    const viewModel = useChatPanelViewModel(props);

    return <ChatPanelView {...viewModel} />;
};

export default ChatPanelRuntime;
